import { Page } from '@/components/page';

export function Profile() {
  return (
    <Page title="Profile">
    </Page>
  );
}